export default __webpack_public_path__ + "static/bbq-full-03-5ac128cc651d5af92fcc4d98288fac4c.jpg";